<template>
  <GradeReview/>
</template>


<script>
import GradeReview from '@/components/review/GradeReview'
import Store from './LiveGradeReview.store'

export default {
  components: { GradeReview },
  created() {
    this.$store.loadStoreModule({ module: Store })
  },
}
</script>